<template>
    <div class="">
        <Modal
            v-for="(modal, i) in modals"
            :key="i"
            :name="modal.modalName"
            :footer-bar-text="modal.highlightBar"
            :footer-bar-link="modal.highlightBarLink"
            close-icon-variant="hidden"
            :closable="modal.closable"
            close-text="Cancel & Return"
        >
            <template v-slot="{ onAcceptAndClose }">
                <img class="mx-auto mb-4 min-h-32 w-24 sm:mb-12 sm:w-36" :src="modal.icon" alt="" />

                <h3 class="w-full mb-4 font-sans font-medium text-center text-blue-500 h2">
                    {{ modal.heading }}
                </h3>
                <p class="mb-4 mb-8 text-center text-blue-500" v-html="modal.text"></p>
                <div
                    v-if="modal.textBox"
                    class="px-3 py-6 mt-4 text-center text-blue-500 border border-grey-150 small wysiwyg wysiwyg--condensed"
                    v-html="modal.textBox"
                ></div>
                <button
                    v-if="['serviceTypeChoice', 'serviceStepComplete'].includes(modal.trigger)"
                    class="w-full mt-8 btn"
                    @click="onAcceptAndClose"
                >
                    Accept & Continue
                </button>
            </template>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/../vue/_base/Modal.vue';

export default {
    components: {
        Modal
    },

    props: {
        modals: {
            type: Array,
            required: true
        }
    }
};
</script>
